import React ,{useState} from 'react'
import './property-coverage.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const PropertyCoverage = () => {
    const [hrefData, setHrefData] = useState();
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business owner insurance", link: "/what-we-offer/insurance-products/business-owner-insurance" },
        { label: "Property coverage", link: "/what-we-offer/insurance-products/business-owner-insurance/property-coverage" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "difference",
            label: "The Sentry difference",
        },
        {
            id: "Ourcommercialproperty",
            href: "Ourcommercialproperty",
            label: "Our commercial property insurance policies",
        },
        {
            id: "help",
            href: "help",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Protecting your business by getting to know your business',
        blue_para: 'When it comes to commercial property insurance, communication makes all the difference. We’re here to help you protect your business, and we believe the first step is learning about your business—directly from you. That way, we can help you determine the types of coverage you need, at rates that make financial sense for you. And if you experience a covered loss, our knowledgeable claims team will handle your claim quickly and fairly. That’s our commitment to service in action.',
        purple_icon: images['Icon_of_two_green_cups.svg'],
        purple_heading: 'Insurance industry knowledge you can trust',
        purple_para: "Finding the right property insurance doesn’t need to be confusing. We’ll help you navigate our policies and answer any questions you have.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['people-planting-icon.svg'],
            para: 'Choosing the right commercial property coverage is vital for your company. After all, it’s about more than protecting your building, equipment, inventory, and income when the unexpected becomes reality. It’s about confidence. At Sentry, that’s what we offer.',
            para1: 'With our range of coverages—personal property, business income, building, and equipment breakdown—and dedication to personal service, you can trust us to be there for you.'
        },  
    ];
    return (
        <>
            <div className='property-coverage'>
                {/* hero section */}
                <Hero img={images["Two_people_in_safety_gear_planning_in_warehouse.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Property coverage" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} hrefData={hrefData}
                    setHrefData={setHrefData} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card' id='difference'>
                        <h1>The Sentry difference</h1>
                        <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard id='Ourcommercialproperty' Title="Our commercial property insurance policies" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} id='help'/>
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default PropertyCoverage